import { TableColumn } from "../table/TableColumn";

const PresetOutputModeColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
    }
];

export default PresetOutputModeColumns;
